<template>
    <div>

        <base-card v-for="(customer, index) in customerList" v-bind:key="index" class="box-selection"> <!-- v-for -->
            <div>
                <p class="customer-name">{{customer.name}}</p>
                <p class="customer-phone">{{Utils.phoneMask(customer.phone)}}</p>
            </div>
            <div>
                <p class="customer-select" @click="emitSetCustomer(customer)">
                    <i v-if="selectedCustomer && selectedCustomer.id == customer.id" class="far fa-check-circle"></i>
                    <i v-else class="far fa-chevron-circle-right"></i>
                </p>
            </div>
        </base-card>
        <div @click="emitAddCustomer()">
            <base-add text="Adicionar cliente" height="105px" class="mb_20" />
        </div>
    </div>
</template>
<script>

import BaseCard from '@/components/Card';
import BaseAdd from '@/components/Add';
import Utils from '@/utils';

export default {
    components: {
        BaseCard,
        BaseAdd,
    },
    props: {
        customers: { type: Array, default: null },
        selectedCustomer: { type: Object, default: null }
    },
    data() {
        return {
            Utils
        }
    },
    computed: {
        customerList () {
            return this.$props.customers || [];
        }
    },
    methods: {
        emitSetCustomer(customer) {
            this.$emit('setCustomer', customer);
        },
        emitAddCustomer() {
            this.$emit('addCustomer');
        }
    }
}
</script>
<style scoped>
  .box-selection{
      padding: 30px 20px;
      color: var(--default);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      opacity: .9;
  }
  .customer-name{
    font-size: 1.8em;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: capitalize;
  }
  .customer-phone{
      margin-top: 15px;
      font-size: 1.3em;
  }
  .customer-select{
      font-size: 2.8em;
      margin: 0 10px 0 30px;
  }
</style>